module.exports = __webpack_public_path__ + "img/img_sfz1.12c248df.png";